import React from 'react';
// import BigLink from './BigLink';

const FastLinks = ({ data }) => {
  const newData = data[1];

  return (
    <div className="fast-links row center-sm util-txt-center">
      <a href={newData.url}>
        <i className={`${newData.iconClassName}`} />
        <div className="link-description">
          <h4>{newData.heading}</h4>
          <h3>{newData.description}<i className="ic icon-bold-arrow" /></h3>
        </div>

      </a>
    </div>
  );
};


FastLinks.defaultProps = {
  data: [],
};

// FastLinks.defaultProps = {
//   data: [
//     {
//       url: '//www.beaches.com/about/resort-family/',
//       iconClassName: 'icon-fat-pin',
//       heading: 'Our Destinations',
//       description: 'On the Caribbean\'s Best Beaches'
//     },
//     {
//       url: '/compare/',
//       iconClassName: 'icon-compare',
//       heading: 'Compare Resorts',
//       description: 'Our resorts are uniquely different'
//     },
//   ]
// };

export default FastLinks;



// WEBPACK FOOTER //
// ./js/components/global/menu/FastLinks.js